module.exports = __webpack_public_path__ + "0dc01126244cfc5c48dd02338e04818e.png";